import React from 'react'
import { css } from 'emotion'
import { LatexExample } from './LatexExample'

function App() {
  return (
    <div className="App">
      <h2 className={css`font-family: Helvetica; font-weight: 400;`}>
        CodeMirror 6
      </h2>

      <LatexExample fileName="example-1" />
    </div>
  )
}

export default App
